import invariant from "tiny-invariant";

/**
 * Generates a list of dates with a given range, anchored around a specified
 * date. Dates are sorted in ascending order.
 * @param anchorDate The anchored date to generate the range around.
 * @param numVisibleDaysForward Number of days forward to generate ahead of the viewingDate.
 * @param numVisibleDaysBackward Number of days backward to generate ahead of the viewingDate.
 */
export const generateDateRange = (
    anchorDate: Date,
    numVisibleDaysForward: number,
    numVisibleDaysBackward: number,
): Date[] => {
    invariant(numVisibleDaysForward >= 0, "numVisibleDaysForward must be 0 or positive number");
    invariant(numVisibleDaysBackward >= 0, "numVisibleDaysBackward must be 0 or positive number");
    const dates: Date[] = [];
    let currentDate = new Date(anchorDate);

    // Note: stop before 0 because we don't want to include the firstVisibleDate twice.
    for (let i = numVisibleDaysBackward; i >= 0; i--) {
        const prevDay = new Date(currentDate);
        dates.push(prevDay);
        currentDate.setDate(currentDate.getDate() - 1);
    }

    let currentDate2 = new Date(anchorDate);
    currentDate2.setDate(currentDate2.getDate() + 1);
    // Start at 1 because we increment the current date above
    for (let i = 0; i < numVisibleDaysForward; i++) {
        const nextDay = new Date(currentDate2);
        dates.push(nextDay);
        currentDate2.setDate(currentDate2.getDate() + 1);
    }
    return dates.sort((a, b) => a.getTime() - b.getTime());
};
